// TODO (VENN-25267) change the metrics list to the finalized one
import type { CustomizableMetric } from 'venn-utils';

export const PEER_GROUPS_METRICS: CustomizableMetric[] = [
  {
    key: 'periodReturn',
    label: 'Return (Analysis Period)',
    dataType: 'PERCENTAGE',
    analysisType: 'PEER_GROUP_HISTORICAL_PERFORMANCE_ANALYSIS',
    category: 'Historical Performance',
    analysisResultKey: 'peerGroupAnalysis',
    metricPath: 'FULL.CUMULATIVE_RETURN',
  },
  {
    key: 'ytdReturn',
    label: 'Return (YTD)',
    dataType: 'PERCENTAGE',
    analysisType: 'PEER_GROUP_HISTORICAL_PERFORMANCE_ANALYSIS',
    category: 'Historical Performance',
    analysisResultKey: 'peerGroupAnalysis',
    metricPath: 'YTD.CUMULATIVE_RETURN',
  },
  {
    key: 'YEAR_5-periodReturn',
    label: 'Return (5Y)',
    dataType: 'PERCENTAGE',
    analysisType: 'PEER_GROUP_HISTORICAL_PERFORMANCE_ANALYSIS',
    category: 'Historical Performance',
    analysisResultKey: 'peerGroupAnalysis',
    metricPath: 'YEAR_5.CUMULATIVE_RETURN',
  },
  {
    key: 'sharpe',
    label: 'Sharpe Ratio',
    dataType: 'NUMERIC',
    analysisType: 'PEER_GROUP_HISTORICAL_PERFORMANCE_ANALYSIS',
    category: 'Historical Performance',
    analysisResultKey: 'peerGroupAnalysis',
    metricPath: 'FULL.SHARPE_RATIO',
  },
  {
    key: 'YEAR_5-sharpe',
    label: 'Sharpe Ratio (5Y)',
    dataType: 'NUMERIC',
    analysisType: 'PEER_GROUP_HISTORICAL_PERFORMANCE_ANALYSIS',
    category: 'Historical Performance',
    analysisResultKey: 'peerGroupAnalysis',
    metricPath: 'YEAR_5.SHARPE_RATIO',
  },
  {
    key: 'YEAR_5-volatility',
    label: 'Volatility (5Y)',
    dataType: 'PERCENTAGE',
    analysisType: 'PEER_GROUP_HISTORICAL_PERFORMANCE_ANALYSIS',
    category: 'Historical Performance',
    analysisResultKey: 'peerGroupAnalysis',
    metricPath: 'YEAR_5.ANNUALIZED_VOLATILITY',
  },
];
